var CapabilityDetector = require("./CapabilityDetector");

var detector = new CapabilityDetector();

var capability = function capability(name) {
  return detector.test(name);
};

capability.define = function (name, test) {
  detector.define(name, test);
};

capability.check = function (name) {
  detector.check(name);
};

capability.test = capability;
module.exports = capability;